export default __webpack_public_path__ + "static/media/galaxy-mobile.81ef7ba0.png";